import React, { useEffect, useState } from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import { TextField } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { Autocomplete } from '@material-ui/lab'
import MenuItem from '@material-ui/core/MenuItem'
import { useStyles } from './styles'

const initialSearch = {
  linea: null,
  unidadNegocio: null,
  marca: null,
  estado: '',
}
const SearchFilterVehiculos = (props) => {
  const {
    lineas,
    handleChange,
    unidadNegocios,
    marcas,
    controlComponent,
  } = props

  const classes = useStyles()
  const [searchControl, setSearchControl] = useState(initialSearch)

  useEffect(() => {
    setSearchControl(initialSearch)
  }, [controlComponent])

  return (
    <>
      <div className={classes.contentSearch}>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.unidadNegocio}
            options={unidadNegocios}
            getOptionLabel={(option) => option.nombre}
            renderInput={(params) => (
              <TextField {...params} label="Unidades de negocio" />
            )}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.nombre : null
              setSearchControl({
                ...searchControl,
                unidadNegocio: newVal,
              })
              handleChange('unidadNegocio', choose)
            }}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.marca}
            options={marcas}
            getOptionLabel={(option) => option.marca}
            renderInput={(params) => <TextField {...params} label="Marca" />}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.marca : null
              setSearchControl({
                ...searchControl,
                marca: newVal,
              })
              handleChange('marca', choose)
            }}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="socio-native-simple">Estado</InputLabel>
          <Select
            value={searchControl.estado}
            className={classes.selectSearch}
            onChange={(e) => {
              setSearchControl({ ...searchControl, estado: e.target.value })
              handleChange('estado', e.target.value)
            }}
            inputProps={{
              name: 'estado',
              id: 'socio-native-simple',
            }}
          >
            <MenuItem value={null}>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="SI">Activo</MenuItem>
            <MenuItem value="NO">Inactivo</MenuItem>
          </Select>
        </FormControl>

        <br />
      </div>
    </>
  )
}

export default SearchFilterVehiculos
